import React, { useState } from "react";
import { observer } from "mobx-react";
import * as echarts from "echarts/core";
import { GridComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import ReactEcharts from "echarts-for-react";
import CircularProgress from "@mui/material/CircularProgress";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";

echarts.use([GridComponent, BarChart, CanvasRenderer]);

const TaskProgressEchart = ({ taskObject }) => {
  const startDate =
    taskObject[0].plannedStartDate === undefined ||
      taskObject[0].plannedStartDate === null
      ? new Date()
      : new Date(taskObject[0].plannedStartDate);
  let months = [];
  const [loadingPrebaseline, setloadingPrebaseline] = useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setloadingPrebaseline(false);
  };

  let prebaselinedPeriods =
    taskObject[0].plannedStartDate === undefined ||
      taskObject[0].plannedStartDate === null
      ? []
      : taskObject[0].project.getUnarcPrebaselinePeriods(setloadingPrebaseline);

  // Get the expected Progress from all the tasks
  const progress = taskObject.map((x) =>
    x.plannedProgress.map((y) => y.expectedProgress)
  );

  const names = taskObject.map((x) => x.name);

  const monthDict = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const axis = [];
  const baselineXPos = [];

  months = taskObject[0].plannedProgress.map((x, index) => {
    let mm = String(((startDate.getMonth() + index) % 12) + 1);
    let yyyy = startDate.getFullYear();

    if (mm === "12") {
      startDate.setYear(startDate.getFullYear() + 1);
    }

    let label = x.period + "\n(" + monthDict[mm] + " " + yyyy + ")";
    axis.push(label);

    if (prebaselinedPeriods !== undefined && prebaselinedPeriods !== null) {
      if (prebaselinedPeriods.includes(x.period)) {
        baselineXPos.push(label);
      }
    }

    let tooltip = "Date: " + monthDict[mm] + "/" + yyyy;

    return tooltip;
  });

  const objects = progress.map((x, index) => {
    return { name: names[index], data: x, type: "bar" };
  });

  baselineXPos.forEach((label) => {
    objects.push({
      type: "line",
      name: "Baseline",
      stack: "top",
      markLine: {
        symbol: "none",
        label: {
          show: false,
        },
        lineStyle: {
          color: "grey",
          type: "solid",
          width: 3,
        },
        data: [
          {
            name: "Baseline",
            xAxis: label,
          },
        ],
      },
    });
  });

  const generateOverall = (param) => {
    let total = 0;
    progress.forEach((data) => {
      data.forEach((x, index) => {
        if (index <= param) {
          total += x;
        }
      });
    });
    return total;
  };

  const options = {
    title: {
      left: "center",
      text: "Task Progress",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: (params) => {
        let Tooltip = "";
        params.forEach((param) => {
          Tooltip =
            months[param.dataIndex] +
            "<br/> Progress this Month: " +
            param.data +
            "%<br/>Overall Progress: " +
            generateOverall(param.dataIndex) +
            "%";
        });
        return Tooltip;
      },
    },
    grid: {
      containLabel: true,
      show: true,
      //backgroundColor: "rgba(0, 0, 0, 1)",
    },
    xAxis: {
      name: "Period",
      data: axis,
    },

    yAxis: {
      name: " Expected Progress",
    },
    dataZoom: [
      {
        type: "slider",
        xAxisIndex: 0,
        bottom: 25,
        filterMode: "none",
      },
      {
        type: "slider",
        yAxisIndex: 0,
        filterMode: "none",
      },
      {
        type: "inside",
        xAxisIndex: 0,
        filterMode: "none",
      },
      {
        type: "inside",
        yAxisIndex: 0,
        filterMode: "none",
      },
    ],
    legend: {
      orient: "vertical",
      align: "right",
      bottom: "80%",
      right: "10%",
      borderWidth: 1,
    },
    series: objects,
  };

  return (
    <div>
      <ReactEcharts option={options} />
      <Snackbar
        title="Load PreBaseline Message"
        open={loadingPrebaseline}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          <div>
            <CircularProgress color="inherit" />
            Please wait while the baseline snapshot is being generated, this may
            take several minutes.
          </div>
        </Alert>
      </Snackbar>
    </div>
  );
};

export default observer(TaskProgressEchart);
